import { fliptService } from '../../services/fliptService'

const SET_CUTOVER = 'SET_CUTOVER'

const state = {
  on: false
}

const getters = {
  on: state => state.on
}

const actions = {
  // Asks Flipt for sfp-supplier-portal-cutover with the canonical login; false when Flipt fails.
  async refresh ({ commit, rootState }) {
    const info = (rootState.user.data && rootState.user.data.info) || {}
    const on = await fliptService.isSupplierPortalCutoverEnabled(info.login || '')
    commit(SET_CUTOVER, on)
    return on
  }
}

const mutations = {
  [SET_CUTOVER] (state, on) {
    state.on = on
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/cutover.js